module.exports = require("canvg");


//////////////////
// WEBPACK FOOTER
// external "canvg"
// module id = BHGR
// module chunks = 33